import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import _ from 'lodash-es';
import {SectionType} from '../../mystudies/_study_constants';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-shareholder-ownership-validation-dialog',
  templateUrl: './shareholder-ownership-validation-dialog.component.html',
  styleUrls: ['./shareholder-ownership-validation-dialog.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ShareholderOwnershipValidationDialogComponent implements OnInit {
  public shareholderIndependencyCriteria = 0;
  public shareholderIndependencyThreshold = 0;
  public searchStrategyId = 0;
  sectionType: SectionType;
  showValidationMessage = false;
  validationMessage: string;
  public readOnly = false;
  initialShareholderIndependencyCriteria: number;
  initialShareholderIndependencyThreshold: number;

  constructor(
    private activeModal: NgbActiveModal,
    private configService: ConfigService,
  ) { }

  async ngOnInit() {
    // Set initial values (replace with actual initial values as needed)
    this.initialShareholderIndependencyCriteria = this.shareholderIndependencyCriteria;
    this.initialShareholderIndependencyThreshold = this.shareholderIndependencyThreshold;
    this.validateSave();
  }

  async close() {
    this.activeModal.close();
  }

  validateSave(): boolean {
    this.validationMessage = '';
    this.showValidationMessage = false;
    if (this.shareholderIndependencyCriteria === undefined || this.shareholderIndependencyCriteria === null || this.shareholderIndependencyCriteria === 0) {
      this.showValidationMessage = true;
      this.validationMessage = 'Please select Validation method between Shareholder Name and Shareholder Name & ID';
    }
    else if (!_.isNumber(this.shareholderIndependencyThreshold)
      || this.shareholderIndependencyThreshold < 1 || this.shareholderIndependencyThreshold > 100) {
      this.showValidationMessage = true;
      this.validationMessage = 'Please enter percentage value (numeric value between 1 and 100) for Independency Threshold.';
    }
    if (this.showValidationMessage) {
      return false;
    } else {
      return true;
    }
  }
  
  async save() {
    if (!this.validateSave()) {
      return false;
    }
    const resultSet = {
      searchStrategyId: this.searchStrategyId,
      shareholderIndependencyCriteria: this.shareholderIndependencyCriteria,
      shareholderIndependencyThreshold: this.shareholderIndependencyThreshold,
    };
    this.activeModal.close(resultSet);
    return true;
  }
  shareholderIndependencyCriteriaChange() {
    this.validateSave()
  }
}
